import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About'
import Payment from '../views/Payment.vue'
import TermsAndCondition from "../views/TermsAndCondition";
import PrivacyPolicy from "../views/PrivacyPolicy";
import PaymentCompleted from "../views/PaymentCompleted";
import ThankYou from "../views/ThankYou";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about-us',
    name: 'About',
    component: About
  },
  {
    path: '/payment',
    name: 'Payment',
    component: Payment
  },
  {
    path: '/terms-and-conditions',
    name: 'TermsAndCondition',
    component: TermsAndCondition
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  },
  {
    path: '/payment-completed',
    name: 'PaymentCompleted',
    component: PaymentCompleted
  },
  {
    path: '/thank-you',
    name: 'ThankYou',
    component: ThankYou
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/success',
    name: 'Success',
    component: () => import(/* webpackChunkName: "about" */ '../views/success.vue')
  },
  {
    path: '/topup-success',
    name: 'TopupSuccess',
    component: () => import(/* webpackChunkName: "about" */ '../views/TopupSuccess.vue')
  },
  {
    path: '/topup-history',
    name: 'TopupHistory',
    component: () => import(/* webpackChunkName: "about" */ '../views/TopupHistory')
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import(/* webpackChunkName: "about" */ '../views/ResetPassword')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
})

export default router
